import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Toaster, toast } from 'react-hot-toast';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import portadaImage from '../img/portada.jpg'; 
import '../App2.css';  // Asegúrate de importar el archivo CSS

const Sesion = () => {
    const navigate = useNavigate();
    const [correo, setCorreo] = useState('');
    const [contraseña, setContraseña] = useState('');
    const [mostrarContraseña, setMostrarContraseña] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();

        const loadingToastId = toast.loading('Iniciando sesión...');

        try {
            // Limpiar cualquier dato previo en localStorage al intentar un nuevo inicio de sesión
            localStorage.clear();

            const formData = new FormData();
            formData.append('username', correo.toLowerCase()); // El backend espera 'username'
            formData.append('password', contraseña);

            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/token`, formData);

            // Guardar el token en el localStorage
            const accessToken = response.data.access_token;
            localStorage.setItem('access_token', accessToken);

            // Solicitar los detalles del usuario
            const userResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/users/me/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            const { rol, numero_grupo, nombre_get } = userResponse.data;

            // Guardar los detalles en localStorage
            localStorage.setItem('nombre_get', nombre_get || '');  // Utiliza 'nombre_get' en lugar de 'nombre'
            localStorage.setItem('rol', rol || '');
            localStorage.setItem('grupo', numero_grupo || '');

            toast.dismiss(loadingToastId);
            toast.success('Inicio de sesión exitoso');

            // Navegación basada en el rol del usuario
            switch (rol) {
                case 'Staff':
                    navigate('/menustaff');
                    break;
                case 'Lider':
                case 'Subrogante':
                    navigate('/menulider');
                    break;
                case 'Senior GET':
                    navigate('/RevisarActividadesSeniorGET');
                    break;
                case 'Socio GET':
                    navigate('/menusocio_GET');
                    break;
                case 'Solicitante GET':
                    navigate('/menusolicitante');
                    break;
                default:
                    toast.error('Rol no reconocido');
            }
        } catch (error) {
            toast.dismiss(loadingToastId);
            toast.error('Correo o contraseña incorrectos');
            console.error('Error al iniciar sesión:', error);
        }
    };

    return (
        <div className="sesion-container-unique">
            <div className="sesion-content-unique">
                <div className="form-container-unique">
                    <h1 className="heading-unique">Iniciar Sesión</h1>
                    <form onSubmit={handleLogin}>
                        <div className="form-group-unique">
                            <label htmlFor="correo" className="label-unique">Correo:</label>
                            <input
                                type="email"
                                id="correo"
                                value={correo}
                                onChange={(e) => setCorreo(e.target.value)}
                                placeholder="Ingresa tu correo"
                                required
                                className="input-unique"
                            />
                        </div>
                        <div className="form-group-unique">
                            <label htmlFor="contraseña" className="label-unique">Contraseña:</label>
                            <div className="input-container-unique">
                                <input
                                    type={mostrarContraseña ? 'text' : 'password'}
                                    id="contraseña"
                                    value={contraseña}
                                    onChange={(e) => setContraseña(e.target.value)}
                                    placeholder="Ingresa tu contraseña"
                                    required
                                    className="input-unique"
                                />
                                <span
                                    className="icon-container-unique"
                                    onClick={() => setMostrarContraseña(!mostrarContraseña)}
                                >
                                    {mostrarContraseña ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>
                        <button type="submit" className="button-unique">
                            Iniciar Sesión
                        </button>
                    </form>
                    <Toaster />
                </div>
                <div className="image-container-unique">
                    <img src={portadaImage} alt="Portada" className="image-unique" />
                </div>
            </div>
        </div>
    );
};

export default Sesion;
